import { setUseWhatChange } from '@simbathesailor/use-what-changed';
import { configure } from 'mobx';
import { createRoot } from 'react-dom/client';

import './index.css';

import * as Sentry from '@sentry/react';

import App from './app/App';

setUseWhatChange(import.meta.env.DEV);

configure({ enforceActions: 'never' });

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://c213899c9283479cca4ece9a912058bf@o64216.ingest.us.sentry.io/4509197447987200',
  });
}

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(<App />);
